<div class="dsforms-preview-layout-container">
    <dsf-dsforms-content-layout
        *ngIf="formToPopulate"
        [formToPopulate]="formToPopulate"
        [displayChoice]="displayChoice"
        [formNotFound]="formNotFound"
    ></dsf-dsforms-content-layout>
</div>
